webpackJsonp([2,4],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_InputValidator = (function (_Abstract2) {
	  _inherits(Component_InputValidator, _Abstract2);
	
	  function Component_InputValidator(el, options) {
	    _classCallCheck(this, Component_InputValidator);
	
	    _get(Object.getPrototypeOf(Component_InputValidator.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	    console.log("INPUT VALIDATOR");
	    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	    this.bindEvents();
	  }
	
	  _createClass(Component_InputValidator, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.find("input").blur(function (e) {
	        return _this.onInputBlurred(e);
	      });
	      this.$el.find("input").keyup(function (e) {
	        return _this.onInputKeyUp(e);
	      });
	      // this.$el.find(" input").keydown((e) => this.onInputKeyDown(e));
	
	      if (typeof this.options.submit_button_selector !== "undefined") {
	        this.$el.find(this.options.submit_button_selector).click(function (e) {
	          return _this.onSubmitButtonClicked(e);
	        });
	      }
	    }
	  }, {
	    key: "onInputBlurred",
	    value: function onInputBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onInputKeyDown",
	    value: function onInputKeyDown(e) {
	      var $input = $(e.currentTarget);
	      return this.forceCharacterLimits($input);
	    }
	  }, {
	    key: "onInputKeyUp",
	    value: function onInputKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "forceCharacterLimits",
	    value: function forceCharacterLimits($element) {
	      var characterLimit = $element.data("character-limit");
	      if (!characterLimit) {
	        return true;
	      }
	
	      var elementValue = $element.val();
	      if (elementValue.length > characterLimit) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "validateElement",
	    value: function validateElement($element) {
	
	      if (!$element.closest(".c-label-input-ctn").hasClass("required")) {
	        return;
	      }
	
	      var inputType = $element.attr("type");
	      var bValidInput = $element.val();
	      if (inputType.toLowerCase() === "email") {
	        bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
	      }
	
	      if ($element.data("match")) {
	        var matchSelector = $element.data("match");
	        var $elementToMatch = $(matchSelector);
	        if ($elementToMatch.length) {
	          if ($element.val() !== $elementToMatch.val()) {
	            bValidInput = false;
	          }
	        } else {
	          console.log("input-validator: Failed to find matching element to compare data!");
	        }
	      }
	
	      if (bValidInput) {
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "onSubmitButtonClicked",
	    value: function onSubmitButtonClicked(e) {
	      var context = this;
	      var bAllValidated = true;
	      this.$el.find(".required input").each(function () {
	        var $input = $(this);
	        if (!context.validateElement($input)) {
	          bAllValidated = false;
	        }
	      });
	
	      if (bAllValidated) {
	        this.$el.find(".form-is-valid").removeClass('-hide');
	        this.$el.find(".form-is-invalid").addClass('-hide');
	      } else {
	        this.$el.find(".form-is-valid").addClass('-hide');
	        this.$el.find(".form-is-invalid").removeClass('-hide');
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    }
	  }]);
	
	  return Component_InputValidator;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_InputValidator;
	module.exports = exports["default"];

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_InputValidatorv2 = (function (_Abstract2) {
	  _inherits(Component_InputValidatorv2, _Abstract2);
	
	  function Component_InputValidatorv2(el, options) {
	    _classCallCheck(this, Component_InputValidatorv2);
	
	    _get(Object.getPrototypeOf(Component_InputValidatorv2.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), "component");
	    this.EMAIL_REGULAR_EXPRESSION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    this.bindEvents();
	    $("select.c-label-select__fields").selectric({
	      disableOnMobile: false,
	      nativeOnMobile: false,
	      onChange: function onChange() {
	        $(".selectric-c-label-select__fields").removeClass("is-invalid");
	      }
	    }).on("selectric-before-open", function () {
	      if ($(".selectric-c-label-select__fields").hasClass("is-invalid")) {
	        $(".selectric-c-label-select__fields").removeClass("is-invalid");
	      }
	    });
	  }
	
	  _createClass(Component_InputValidatorv2, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.find("input").blur(function (e) {
	        return _this.onInputBlurred(e);
	      });
	      this.$el.find("input").keyup(function (e) {
	        return _this.onInputKeyUp(e);
	      });
	      this.$el.find("textarea").blur(function (e) {
	        return _this.onTextareBlurred(e);
	      });
	      this.$el.find("textarea").keyup(function (e) {
	        return _this.onTextareKeyUp(e);
	      });
	      if (typeof this.options.submit_button_selector !== "undefined") {
	        this.$el.find(this.options.submit_button_selector).click(function (e) {
	          return _this.onSubmitButtonClicked(e);
	        });
	      }
	    }
	  }, {
	    key: "onInputBlurred",
	    value: function onInputBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onInputKeyDown",
	    value: function onInputKeyDown(e) {
	      var $input = $(e.currentTarget);
	      return this.forceCharacterLimits($input);
	    }
	  }, {
	    key: "onInputKeyUp",
	    value: function onInputKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onTextareKeyUp",
	    value: function onTextareKeyUp(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "onTextareBlurred",
	    value: function onTextareBlurred(e) {
	      var $input = $(e.currentTarget);
	      this.validateElement($input);
	    }
	  }, {
	    key: "forceCharacterLimits",
	    value: function forceCharacterLimits($element) {
	      var characterLimit = $element.data("character-limit");
	      if (!characterLimit) {
	        return true;
	      }
	
	      var elementValue = $element.val();
	      if (elementValue.length > characterLimit) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "validateTextarea",
	    value: function validateTextarea($element) {
	      if ($element.val()) {
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "validateElement",
	    value: function validateElement($element) {
	      if (!$element.closest(".c-label-input-ctn").hasClass("required")) {
	        return;
	      }
	
	      var inputType = $element.attr("type");
	      var bValidInput = $element.val();
	      if (inputType.toLowerCase() === "email") {
	        bValidInput = this.EMAIL_REGULAR_EXPRESSION.test($element.val());
	      }
	
	      if ($element.data("match")) {
	        var matchSelector = $element.data("match");
	        var $elementToMatch = $(matchSelector);
	        if ($elementToMatch.length) {
	          if ($element.val() !== $elementToMatch.val()) {
	            bValidInput = false;
	          }
	        } else {
	          console.log("input-validator: Failed to find matching element to compare data!");
	        }
	      }
	
	      if (bValidInput) {
	        $(".-error").html("Comments Field<span>*</span>");
	        $element.removeClass("invalid-input");
	        $element.closest(".c-label-input-ctn").removeClass("invalid-input");
	        return true;
	      } else {
	        $(".-error").html("Comments<span>*</span>");
	        $element.addClass("invalid-input");
	        $element.closest(".c-label-input-ctn").addClass("invalid-input");
	        return false;
	      }
	    }
	  }, {
	    key: "onErrorScrollTop",
	    value: function onErrorScrollTop() {
	      $("html,body").animate({
	        scrollTop: $(".-scrolltop").offset().top - 30
	      }, "fast");
	    }
	  }, {
	    key: "formValidation",
	    value: function formValidation(bAllValidated, e) {
	      var context = this;
	      if (bAllValidated) {
	        context.$el.find(".form-is-valid").removeClass("-hide");
	        context.$el.find(".form-is-invalid").addClass("-hide");
	        // Change checkbox value when checked
	        var $signMeUp = $('input[name="subscribe"]');
	        if ($signMeUp.prop("checked")) {
	          $(".js-form-stream-val").attr("value", 1);
	        } else {
	          $(".js-form-stream-val").attr("value", 0);
	        }
	        var htmlLoader = "<div class='-loading -loader-wrapper'><div class='uil-spin-css'><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div></div></div>";
	        $(".cta-input-sugarform--send-btn").after(htmlLoader);
	        $(".cta-input-sugarform--send-btn").css("visibility", "hidden");
	
	        if (window.location.hostname === "furnware-static.uniondigital.co.nz" || window.location.hostname === "localhost") {
	          return;
	        }
	        if ($(e.currentTarget).hasClass("stem-submit-btn")) {
	          context.setCookie("stemlearningpopup", "clicked", 100000);
	        }
	        $("#aspnetForm").attr("action", $(".cta-input-form").data("sugar-market-post-url"));
	        $("#aspnetForm").unbind("submit").removeAttr("onsubmit");
	        $("#aspnetForm").submit();
	      } else {
	        context.$el.find(".form-is-valid").addClass("-hide");
	        context.$el.find(".form-is-invalid").removeClass("-hide");
	        grecaptcha.reset();
	        context.onErrorScrollTop();
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      }
	    }
	  }, {
	    key: "recaptchaValidation",
	    value: function recaptchaValidation(context, bAllValidated, e) {
	      $.ajax({
	        type: "GET",
	        url: "/WebApi/ReCaptchaApi/VerifyReCaptcha?reCaptchaResponse=" + grecaptcha.getResponse(),
	        error: function error(response) {
	          bAllValidated = false;
	          $(".g-recaptcha__errormsg").addClass("-hide");
	          context.formValidation(bAllValidated, e);
	        },
	        success: function success(response) {
	          if (response == true) {
	            $(".g-recaptcha__errormsg").addClass("-hide");
	            context.formValidation(bAllValidated, e);
	          } else {
	            bAllValidated = false;
	            $(".g-recaptcha__errormsg").removeClass("-hide");
	            context.formValidation(bAllValidated, e);
	          }
	        }
	      });
	    }
	  }, {
	    key: "onSubmitButtonClicked",
	    value: function onSubmitButtonClicked(e) {
	      var context = this;
	      var bAllValidated = true;
	      var dropdownValidated = true;
	      var textareaValidated = true;
	      if ($(".cta-input-form").data("sugar-market-form") == "contact") {
	        if ($(".c-label-select__fields").val() == "-1") {
	          $(".selectric-c-label-select__fields").addClass("is-invalid");
	          dropdownValidated = false;
	        }
	        if (this.$el.find(".required textarea").length > 0) {
	          textareaValidated = this.validateTextarea(this.$el.find(".required textarea"));
	        }
	        this.$el.find(".required input").each(function () {
	          var $input = $(this);
	          if (!context.validateElement($input)) {
	            bAllValidated = false;
	          }
	        });
	        if (bAllValidated && textareaValidated && dropdownValidated) {
	          this.$el.find(".form-is-valid").removeClass("-hide");
	          this.$el.find(".form-is-invalid").addClass("-hide");
	        } else {
	          this.$el.find(".form-is-valid").addClass("-hide");
	          this.$el.find(".form-is-invalid").removeClass("-hide");
	          this.onErrorScrollTop();
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        context.recaptchaValidation(context, bAllValidated, e);
	      } else {
	        if ($(".c-label-select__fields").length) {
	          if ($(".c-label-select__fields").val() == "-1") {
	            $(".selectric-c-label-select__fields").addClass("is-invalid");
	            bAllValidated = false;
	          }
	        }
	        this.$el.find(".required input").each(function () {
	          var $input = $(this);
	          if (!context.validateElement($input)) {
	            bAllValidated = false;
	          }
	        });
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        context.recaptchaValidation(context, bAllValidated, e);
	      }
	    }
	  }]);
	
	  return Component_InputValidatorv2;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_InputValidatorv2;
	module.exports = exports["default"];

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./_share-base": 21,
		"./_share-base.js": 21,
		"./article-filter": 22,
		"./article-filter.js": 22,
		"./back-button": 23,
		"./back-button.js": 23,
		"./back-to-top": 24,
		"./back-to-top.js": 24,
		"./background-image-rotator": 25,
		"./background-image-rotator.js": 25,
		"./banner-image-rotator": 26,
		"./banner-image-rotator.js": 26,
		"./click-behaviour": 27,
		"./click-behaviour.js": 27,
		"./culture-pop-up": 28,
		"./culture-pop-up.js": 28,
		"./full-screen-html5-video": 29,
		"./full-screen-html5-video.js": 29,
		"./header-desktop": 30,
		"./header-desktop.js": 30,
		"./header-mobile": 31,
		"./header-mobile.js": 31,
		"./hover-behaviour": 32,
		"./hover-behaviour.js": 32,
		"./input-validator": 10,
		"./input-validator-v2": 14,
		"./input-validator-v2.js": 14,
		"./input-validator.js": 10,
		"./move-on-scroll": 33,
		"./move-on-scroll.js": 33,
		"./rotate-on-scroll": 34,
		"./rotate-on-scroll.js": 34,
		"./share-facebook": 36,
		"./share-facebook.js": 36,
		"./share-linkedin": 37,
		"./share-linkedin.js": 37,
		"./share-pinterest": 38,
		"./share-pinterest.js": 38,
		"./share-twitter": 39,
		"./share-twitter.js": 39,
		"./site-wide-banner": 40,
		"./site-wide-banner.js": 40,
		"./social-networks-popup": 41,
		"./social-networks-popup.js": 41,
		"./toggle-child-classes": 42,
		"./toggle-child-classes.js": 42,
		"./vertical-slide": 43,
		"./vertical-slide.js": 43,
		"./video-player": 44,
		"./video-player.js": 44
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 20;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	
	// --
	// SHARE DIALOG
	// --
	//
	// this is base class which the indiviual share classes (facebook,twitter,linkedin,email) extend off
	//
	
	// --
	// USAGE
	// --
	//
	// data-component="share-linkedin" data-component-options='{"shareURL":"[url-to-share]"}'
	//
	// "shareURL" is the site url to share ie http://uniondigital.co.nz
	//
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_share_base = (function (_Abstract2) {
	  _inherits(Component_share_base, _Abstract2);
	
	  function Component_share_base(el, options) {
	    _classCallCheck(this, Component_share_base);
	
	    _get(Object.getPrototypeOf(Component_share_base.prototype), 'constructor', this).call(this, el, $.extend(true, {
	
	      'windowTarget': '',
	      'windowName': '',
	      'windowParams': ''
	
	    }, options), 'component');
	
	    // bind events function
	    this.bindEvents();
	  }
	
	  _createClass(Component_share_base, [{
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var _this = this;
	
	      // bind click event on this element
	      this.$el.on('click', function (e) {
	        return _this.triggerShare(e);
	      });
	    }
	
	    //Makes sure the options stored are the latest based on the elements data options (as may be dynamically replaced)
	  }, {
	    key: 'readLatestElementOptions',
	    value: function readLatestElementOptions() {
	      var latestOptions = this.$el.data("component-options");
	
	      for (var key in latestOptions) {
	        var value = latestOptions[key];
	
	        this.options[key] = value;
	      }
	    }
	
	    // function to pass share dteials to the share dialog
	  }, {
	    key: 'triggerShare',
	    value: function triggerShare(event) {
	
	      this.readLatestElementOptions();
	
	      event.preventDefault();
	
	      this.openSharePopup(this.options.shareURL, this.options.windowTarget, this.options.windowName, this.options.windowParams);
	    }
	
	    // open share dialog
	  }, {
	    key: 'openSharePopup',
	    value: function openSharePopup(shareURL, windowTarget, windowName, windowParams) {
	
	      window.open(windowTarget + encodeURIComponent(shareURL), windowName, windowParams);
	    }
	
	    // open share link
	  }, {
	    key: 'openShareLink',
	    value: function openShareLink(shareURL, windowTarget) {
	
	      window.location.href = windowTarget + encodeURIComponent(shareURL);
	    }
	  }]);
	
	  return Component_share_base;
	})(_systemAbstract2['default']);
	
	exports['default'] = Component_share_base;
	module.exports = exports['default'];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * listings filter js component
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_ArticleFilter = (function (_Abstract2) {
	  _inherits(Component_ArticleFilter, _Abstract2);
	
	  function Component_ArticleFilter(el, options) {
	    _classCallCheck(this, Component_ArticleFilter);
	
	    _get(Object.getPrototypeOf(Component_ArticleFilter.prototype), 'constructor', this).call(this, el, $.extend(true, {
	      filterAttrItem: 'data-item-filters',
	      filterAttrFilter: 'data-filter-by'
	
	    }, options), 'component');
	
	    this.$el.addClass("c-listings-filter");
	
	    this.searchBoxDebounceTimer = null;
	    this.dataFilterSearchTerm = "";
	
	    this.INDEPENDENT_SEARCH_AND_FILTER = true;
	
	    this.$filterItems = this.$el.find('[' + this.options.filterAttrItem + ']');
	    this.$filters = this.$el.find('[' + this.options.filterAttrFilter + ']');
	    this.filterByArray = [];
	    this.$clearFiltersBtn = this.$el.find('.js-clear-filters');
	    this.bindEvents();
	
	    this.initialiseFilterFromURLParamater();
	  }
	
	  _createClass(Component_ArticleFilter, [{
	    key: 'bindEvents',
	    value: function bindEvents() {
	      var _this = this;
	
	      // on filter click
	      this.$filters.on('click', function (e) {
	        return _this.onFilterClicked(e);
	      });
	      this.$clearFiltersBtn.on('click', function (e) {
	        return _this.onClearFilterButtonClicked(e);
	      });
	      this.$el.find(".c-search-input--input").on("keyup", function (e) {
	        return _this.onSearchInputKeyUp(e);
	      });
	      this.$el.find(".c-search-input--input").on("keydown", function (e) {
	        return _this.onSearchInputKeyDown(e);
	      });
	      // this.$el.find(".c-search-input--input").on("keydown",(e) => this.onSearchInputKeyDown(e));
	      this.$el.find(".c-search-input__search-btn").click(function (e) {
	        return _this.onSearchBtnClicked(e);
	      });
	    }
	
	    //http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
	  }, {
	    key: 'getParameterByName',
	    value: function getParameterByName(name, url) {
	      if (!url) {
	        url = window.location.href;
	      }
	
	      name = name.replace(/[\[\]]/g, "\\$&");
	      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	          results = regex.exec(url);
	      if (!results) {
	        return null;
	      }
	
	      if (!results[2]) {
	        return '';
	      }
	
	      return decodeURIComponent(results[2].replace(/\+/g, " "));
	    }
	  }, {
	    key: 'initialiseFilterFromURLParamater',
	    value: function initialiseFilterFromURLParamater() {
	      var filterValue = this.getParameterByName("filter");
	      if (!filterValue) {
	        return;
	      }
	
	      $(".c-article-filters > button").each(function () {
	        if ($(this).text().toLowerCase() === filterValue.toLowerCase()) {
	          $(this).click();
	          return false;
	        }
	      });
	    }
	  }, {
	    key: 'onSearchInputKeyDown',
	    value: function onSearchInputKeyDown(_keyboardEvent) {
	      switch (_keyboardEvent.keyCode) {
	        case 13:
	          //enter
	          {
	            _keyboardEvent.preventDefault();
	            return false;
	            break;
	          }
	      }
	    }
	  }, {
	    key: 'onSearchInputKeyUp',
	    value: function onSearchInputKeyUp(_keyboardEvent) {
	      console.log('on key up');
	      // this.resetSearchBoxDebounceTimer();
	      this.dataFilterSearchTerm = _keyboardEvent.target.value;
	      if ($(_keyboardEvent.target).closest(".c-mobile-sub-page").length) {
	        $(".m-articles .c-search-input .c-search-input--input").val(this.dataFilterSearchTerm);
	      }
	
	      switch (_keyboardEvent.keyCode) {
	        case 13:
	          //enter
	          {
	            this.onEnterPressed(_keyboardEvent);
	            _keyboardEvent.preventDefault();
	            _keyboardEvent.stopPropagation();
	            break;
	          }
	      }
	    }
	  }, {
	    key: 'onSearchInputKeyDown',
	    value: function onSearchInputKeyDown(_keyboardEvent) {
	      console.log('on key down');
	      // this.clearSearchBoxDebounceTimer();
	    }
	  }, {
	    key: 'onSearchBtnClicked',
	    value: function onSearchBtnClicked(_mouseEvent) {
	      this.forceSearch();
	    }
	  }, {
	    key: 'onEnterPressed',
	    value: function onEnterPressed(_keyboardEvent) {
	      this.forceSearch();
	      if ($(_keyboardEvent.target).closest(".c-mobile-sub-page").length) {
	        $(".c-mobile-sub-page .c-mobile-sub-page__header-back-btn").click();
	      }
	    }
	  }, {
	    key: 'forceSearch',
	    value: function forceSearch() {
	      if (this.INDEPENDENT_SEARCH_AND_FILTER) {
	        this.clearFilters();
	        this.resetFilter();
	      }
	      this.clearSearchBoxDebounceTimer();
	      this.onKeyboardSearchDebounceExpired();
	    }
	  }, {
	    key: 'resetSearchBoxDebounceTimer',
	    value: function resetSearchBoxDebounceTimer() {
	      var _this2 = this;
	
	      this.clearSearchBoxDebounceTimer();
	
	      this.searchBoxDebounceTimer = window.setTimeout(function () {
	        return _this2.onKeyboardSearchDebounceExpired();
	      }, 1000);
	    }
	  }, {
	    key: 'onKeyboardSearchDebounceExpired',
	    value: function onKeyboardSearchDebounceExpired() {
	      this.searchBoxDebounceTimer = null;
	      // this.dataFilterSearchTerm = this.$el.find(".c-search-input--input").val();
	
	      this.updateItems(this.filterByArray, true);
	    }
	  }, {
	    key: 'clearSearchBoxDebounceTimer',
	    value: function clearSearchBoxDebounceTimer() {
	      if (!this.searchBoxDebounceTimer) {
	        return;
	      }
	
	      window.clearTimeout(this.searchBoxDebounceTimer);
	      this.searchBoxDebounceTimer = null;
	    }
	  }, {
	    key: 'getAllFilterItems',
	    value: function getAllFilterItems() {
	      return this.$el.find('[' + this.options.filterAttrItem + ']');
	    }
	  }, {
	    key: 'getAllFilters',
	    value: function getAllFilters() {
	      return $(".c-article-filters").find('[' + this.options.filterAttrFilter + ']');
	    }
	  }, {
	    key: 'isClickEventInMobileSubPage',
	    value: function isClickEventInMobileSubPage(e) {
	      return $(e.target).closest(".c-mobile-sub-page").length;
	    }
	  }, {
	    key: 'onFilterClicked',
	    value: function onFilterClicked(e) {
	      e.preventDefault();
	
	      if (this.INDEPENDENT_SEARCH_AND_FILTER) {
	        this.clearSearchBoxDebounceTimer();
	        this.$el.find(".c-search-input--input").val("");
	        this.dataFilterSearchTerm = "";
	      }
	
	      var index = $(e.target).index();
	
	      //More then one may exist (mobile sub page for example)
	      var $clickedTarget = $(e.target);
	      var bCurrentlySelected = $clickedTarget.hasClass("-selected") || $clickedTarget.hasClass("-active");
	      var filterStr = $clickedTarget.attr(this.options.filterAttrFilter);
	
	      $(".c-article-filters").each(function () {
	        var $buttonsIndexOfClickedItem = $(this).find(" > :nth-child(" + (index + 1) + ")");
	        // get target id to filter by
	
	        //if filter is selected remove target id from filter array
	        if (bCurrentlySelected) {
	          $buttonsIndexOfClickedItem.removeClass('-selected').removeClass('-active');
	        } else //if filter is not selected add target id to filter array
	          {
	            $buttonsIndexOfClickedItem.addClass('-selected').addClass("-active");
	          }
	      });
	
	      if (bCurrentlySelected) {
	        this.filterByArray.splice(this.getIndexOfItem(this.filterByArray, filterStr), 1);
	      } else {
	        this.filterByArray.push(filterStr);
	      }
	
	      //update filtered items
	      this.updateItems(this.filterByArray);
	    }
	  }, {
	    key: 'onClearFilterButtonClicked',
	    value: function onClearFilterButtonClicked(e) {
	      e.preventDefault();
	      this.clearFilters();
	      this.resetFilter();
	      this.updateItems(this.filterByArray);
	    }
	  }, {
	    key: 'resetFilter',
	    value: function resetFilter() {
	      //show all items
	      this.filterByArray = [];
	      $('.js-clear-filters').addClass('-selected').addClass('-active');
	    }
	  }, {
	    key: 'clearFilters',
	    value: function clearFilters() {
	      this.getAllFilters().removeClass('-selected').removeClass('-active');
	    }
	  }, {
	    key: 'updateItems',
	    value: function updateItems(arrayOfFilteredItems, bSearchTermTriggered) {
	
	      if (typeof bSearchTermTriggered === "undefined") {
	        bSearchTermTriggered = false;
	      }
	
	      //pass array to function that shows/hides items based on match
	      this.hideFilteredItem(arrayOfFilteredItems, bSearchTermTriggered);
	    }
	  }, {
	    key: 'getIndexOfItem',
	    value: function getIndexOfItem(array, str) {
	
	      // get index of item in array
	      var index = array.indexOf(str);
	      return index;
	    }
	  }, {
	    key: 'hideFilteredItem',
	    value: function hideFilteredItem(arrayOfFilterBy, bSearchTermTriggered) {
	      if (typeof bSearchTermTriggered === "undefined") {
	        bSearchTermTriggered = false;
	      }
	
	      var dataFilterSearchTerm = this.dataFilterSearchTerm;
	      //items that match current array, use filter to determine match
	
	      if (arrayOfFilterBy.length || dataFilterSearchTerm) {
	        var $itemsThatMatch = this.$filterItems.filter(function (index) {
	          var _this3 = this;
	
	          //set match to false
	          var match = false;
	
	          //loop array of target ids to filter by
	          $.each(arrayOfFilterBy, function (index, filterId) {
	
	            // if target id str is found in items filter attribute set to true
	            if ($(_this3).is("[data-item-filters*='" + filterId + "']")) {
	              match = true;
	            }
	          });
	
	          if (dataFilterSearchTerm) {
	            var searchTermMatches = $(".c-tile--title:containsNoCase('" + dataFilterSearchTerm + "'), .c-tile-description:containsNoCase('" + dataFilterSearchTerm + "')", this).length;
	            if (!searchTermMatches) {
	              return false;
	            }
	
	            //If there's no filter selected, then we're filtering by all, so return a match
	            if (!arrayOfFilterBy.length) {
	              return true;
	            }
	          }
	
	          // return match true|false
	          return match;
	        });
	      } else {
	        var $itemsThatMatch = this.$filterItems;
	      }
	
	      //items that do not match
	      var hideItems = this.$filterItems.not($itemsThatMatch);
	      //if no flters are selected and tehre are no items in arary, show all items by default
	      if (arrayOfFilterBy.length <= 0 && !dataFilterSearchTerm) {
	        this.resetFilter();
	      }
	
	      if (arrayOfFilterBy.length > 0) {
	        $('.js-clear-filters').removeClass('-selected').removeClass('-active');
	      }
	
	      var context = this;
	      $(".m-two-col-vertically-stacked-tiles ").fadeOut(function () {
	        var $noResultsFoundFromSearchElement = $(".-no-results-found-from-search-filter-element");
	        context.$filterItems.addClass("-hide");
	        if ($itemsThatMatch.length) {
	          $noResultsFoundFromSearchElement.addClass("-hide");
	          $itemsThatMatch.removeClass("-hide");
	          $(".m-two-col-vertically-stacked-tiles ").show();
	          $("body").trigger("reorder-items");
	          $(".m-two-col-vertically-stacked-tiles ").hide();
	        } else {
	          $noResultsFoundFromSearchElement.removeClass("-hide");
	        }
	
	        $(".m-two-col-vertically-stacked-tiles ").fadeIn();
	      });
	    }
	  }]);
	
	  return Component_ArticleFilter;
	})(_systemAbstract2['default']);
	
	exports['default'] = Component_ArticleFilter;
	module.exports = exports['default'];

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * listings filter js component
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_BackButton = (function (_Abstract2) {
	  _inherits(Component_BackButton, _Abstract2);
	
	  function Component_BackButton(el, options) {
	    _classCallCheck(this, Component_BackButton);
	
	    _get(Object.getPrototypeOf(Component_BackButton.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	
	    this.initialise();
	  }
	
	  _createClass(Component_BackButton, [{
	    key: "initialise",
	    value: function initialise() {
	      this.initialiseListeners();
	    }
	  }, {
	    key: "initialiseListeners",
	    value: function initialiseListeners() {
	      var _this = this;
	
	      this.$el.click(function () {
	        return _this.onElementClick();
	      });
	    }
	  }, {
	    key: "onElementClick",
	    value: function onElementClick() {
	      if (history.length === 1 && typeof this.options.backURL !== "undefined") {
	        //Go to the passed in url for the componenet
	        window.location = this.options.backURL;
	      } else {
	        //go back from the history
	        history.back();
	      }
	    }
	  }]);
	
	  return Component_BackButton;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_BackButton;
	module.exports = exports["default"];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var BackToTop = (function (_Abstract2) {
	  _inherits(BackToTop, _Abstract2);
	
	  function BackToTop(el, options) {
	    _classCallCheck(this, BackToTop);
	
	    _get(Object.getPrototypeOf(BackToTop.prototype), "constructor", this).call(this, el, $.extend(true, {
	      type: false,
	      target_selector: false
	    }, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(BackToTop, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.click(function (e) {
	        return _this.clickBehaviourElementClicked(e);
	      });
	    }
	  }, {
	    key: "clickBehaviourElementClicked",
	    value: function clickBehaviourElementClicked(e) {
	      $("html, body").animate({ scrollTop: 0 }, "slow");
	      return false;
	    }
	  }]);
	
	  return BackToTop;
	})(_systemAbstract2["default"]);
	
	exports["default"] = BackToTop;
	module.exports = exports["default"];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * listings filter js component
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_BackgroundImageRotator = (function (_Abstract2) {
	    _inherits(Component_BackgroundImageRotator, _Abstract2);
	
	    function Component_BackgroundImageRotator(el, options) {
	        _classCallCheck(this, Component_BackgroundImageRotator);
	
	        _get(Object.getPrototypeOf(Component_BackgroundImageRotator.prototype), "constructor", this).call(this, el, $.extend(true, {
	            duration: 3500, //Milliseconds
	            fadeTime: 1500, //Milliseconds
	            baseImagePath: "", //The folder the images live (useful if all of the images are in the same folder, saves on html markup),
	            sameTimeFadeInOut: false // whether or not the previous image should fade out, if set to false, the next image to rotate in simply goes infront and fades in. otherwise both fade at the same time (if true)
	        }, options), 'component');
	
	        if (typeof this.options.images === "undefined" || !this.options.images || !this.options.images.length) {
	            console.log("No images available to be used in background image rotator");
	            return;
	        }
	
	        this.$imageCtn1 = $(document.createElement("div"));
	        this.$imageCtn2 = $(document.createElement("div"));
	
	        this.$el.append(this.$imageCtn1);
	        this.$el.append(this.$imageCtn2);
	
	        this.imageSwapperTimer = null;
	
	        this.imageIndex = -1;
	        this.initialise();
	    }
	
	    _createClass(Component_BackgroundImageRotator, [{
	        key: "initialise",
	        value: function initialise() {
	
	            this.loadAndSwapNextImage();
	        }
	    }, {
	        key: "clearTimer",
	        value: function clearTimer() {
	            if (!this.imageSwapperTimer) {
	                return;
	            }
	
	            window.clearTimeout(this.imageSwapperTimer);
	            this.imageSwapperTimer = null;
	        }
	    }, {
	        key: "resetTimer",
	        value: function resetTimer() {
	            var _this = this;
	
	            this.clearTimer();
	            this.imageSwapperTimer = window.setTimeout(function () {
	                return _this.loadAndSwapNextImage();
	            }, this.options.duration);
	        }
	    }, {
	        key: "loadAndSwapNextImage",
	        value: function loadAndSwapNextImage() {
	            console.log("loadAndSwapNextImage");
	            this.incrementImageIndex();
	            var imageURL = this.getFullImageURLFromIndex(this.imageIndex);
	            this.loadAndSwapImageFromURL(imageURL);
	        }
	    }, {
	        key: "incrementImageIndex",
	        value: function incrementImageIndex() {
	            ++this.imageIndex;
	            if (this.imageIndex >= this.options.images.length) {
	                this.imageIndex = 0;
	            }
	        }
	    }, {
	        key: "getFullImageURLFromIndex",
	        value: function getFullImageURLFromIndex(_index) {
	            var image = this.options.images[_index];
	            var imageSRC = this.options.baseImagePath + image;
	            return imageSRC;
	        }
	    }, {
	        key: "loadAndSwapImageFromURL",
	        value: function loadAndSwapImageFromURL(_url) {
	            var $elementWithCurrentShowingImage = null;
	            var $elementToFadeIn = null;
	
	            if (this.$imageCtn1.is(":visible")) {
	                $elementWithCurrentShowingImage = this.$imageCtn1;
	                $elementToFadeIn = this.$imageCtn2;
	            } else {
	                $elementWithCurrentShowingImage = this.$imageCtn2;
	                $elementToFadeIn = this.$imageCtn1;
	            }
	
	            //   $elementToFadeIn.css("z-index","1");
	            //   $elementWithCurrentShowingImage.css("z-index","0");
	
	            $elementToFadeIn.next().after($elementToFadeIn);
	
	            var context = this;
	            $elementToFadeIn.data("responsive-image", _url);
	            $("body").trigger("responsive-image", { "$responsiveImageTargets": $elementToFadeIn, "fromRotator": true, "onComplete": function onComplete() {
	
	                    if (context.options.sameTimeFadeInOut) {
	                        $elementWithCurrentShowingImage.fadeOut();
	                    }
	
	                    $elementToFadeIn.fadeIn(context.options.fadeTime, function () {
	                        $elementWithCurrentShowingImage.removeData("responsive-image");
	                        $elementWithCurrentShowingImage.css("background-image", "");
	                        $elementWithCurrentShowingImage.hide();
	                        context.resetTimer();
	                    });
	                } });
	
	            //   console.log("loadAndSwapImageFromURL");
	            //   console.log("load image url: " + _url);
	            //   this.$el.data("responsive-image",_url);
	            //   $("body").trigger("responsive-image", {"$responsiveImageTargets":this.$el,"fromRotator":true});
	        }
	    }]);
	
	    return Component_BackgroundImageRotator;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_BackgroundImageRotator;
	module.exports = exports["default"];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/* 
	 * listings filter js component
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_BannerImageRotator = (function (_Abstract2) {
	    _inherits(Component_BannerImageRotator, _Abstract2);
	
	    function Component_BannerImageRotator(el, options) {
	        _classCallCheck(this, Component_BannerImageRotator);
	
	        _get(Object.getPrototypeOf(Component_BannerImageRotator.prototype), "constructor", this).call(this, el, $.extend(true, {
	            duration: ""
	        }, options), 'component');
	
	        this.imageItems = this.$el.find(".m-hero__imgitem");
	        this.checkBackgroundImageInterval = "";
	        if (this.imageItems.length === 0 || this.imageItems.length === 1) {
	            console.log("No images available to be used in banner image rotator");
	            return;
	        }
	        this.initialise();
	    }
	
	    _createClass(Component_BannerImageRotator, [{
	        key: "initialise",
	        value: function initialise() {
	            var _this = this;
	            this.checkBackgroundImageInterval = setInterval(function () {
	                var checkBackgroundImageLoaded = true;
	                for (var i = 0; i < _this.imageItems.length; i++) {
	                    if (!$(_this.imageItems[i]).hasClass("-loaded")) {
	                        checkBackgroundImageLoaded = false;
	                    }
	                }
	                if (checkBackgroundImageLoaded) {
	                    _this.loadAndSwapNextImage();
	                }
	            }, 2000);
	        }
	    }, {
	        key: "loadAndSwapNextImage",
	        value: function loadAndSwapNextImage() {
	            clearInterval(this.checkBackgroundImageInterval);
	            var _this = this;
	            var initialCount = 0;
	            setInterval(function () {
	                $(_this.imageItems[initialCount]).addClass("-hidden").removeClass("-stacking");
	                ++initialCount;
	                if (initialCount >= _this.imageItems.length) {
	                    initialCount = 0;
	                }
	                $(_this.imageItems[initialCount]).removeClass("-hidden").addClass("-stacking");
	            }, this.options.duration);
	        }
	    }]);
	
	    return Component_BannerImageRotator;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_BannerImageRotator;
	module.exports = exports["default"];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_ClickBehaviour = (function (_Abstract2) {
	  _inherits(Component_ClickBehaviour, _Abstract2);
	
	  function Component_ClickBehaviour(el, options) {
	    _classCallCheck(this, Component_ClickBehaviour);
	
	    _get(Object.getPrototypeOf(Component_ClickBehaviour.prototype), "constructor", this).call(this, el, $.extend(true, {
	      type: false,
	      target_selector: false
	    }, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(Component_ClickBehaviour, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.click(function (e) {
	        return _this.clickBehaviourElementClicked(e);
	      });
	    }
	  }, {
	    key: "clickBehaviourElementClicked",
	    value: function clickBehaviourElementClicked(e) {
	
	      if (typeof this.options.desktop_only !== "undefined" && this.options.desktop_only) {
	        var $desktopBreakpointElement = $("#bp-desktop");
	        if ($desktopBreakpointElement.length) {
	          var desktopBreakpointSize = $desktopBreakpointElement.width();
	          if ($(window).outerWidth() < desktopBreakpointSize) {
	            //If its desktop only, and we're below desktop size, then dont do it
	
	            return;
	          }
	        }
	      }
	
	      switch (this.options.type) {
	        case "set-mobile-sub-page":
	          {
	            this.setMobileSubPageContent(e);
	            break;
	          }
	        case "close-mobile-sub-page":
	          {
	            this.closeMobileSubPageContent(e);
	            break;
	          }
	        case "focus":
	          {
	            this.onFocusOnElement();
	            break;
	          }
	
	        case "hide-element-and-empty-child-input":
	          {
	            this.hideElementAndEmptyChildInput();
	            break;
	          }
	
	        case "hide-element-show-element":
	          {
	            this.hideElementShowElement(e);
	            break;
	          }
	
	        case "toggle-class":
	          {
	            this.toggleClass(e);
	            break;
	          }
	
	        case "show-element":
	          {
	            this.showElement();
	            break;
	          }
	
	        default:
	          {
	            console.log("No click behaviour case for : " + this.options.type);
	            return false;
	          }
	      }
	
	      if (typeof this.options.scroll_to_new_clicked_element_position !== "undefined" && this.options.scroll_to_new_clicked_element_position) {
	        // $(window).scrollTop($(e.currentTarget).offset().top);
	      }
	
	      $("body").trigger("responsive-image-check", {});
	    }
	  }, {
	    key: "onFocusOnElement",
	    value: function onFocusOnElement() {
	      var $target = $(this.options.target_selector);
	      if (!$target.length) {
	        console.log("Target Selector element not found with '" + this.options.target_selector + "' selector");
	        return false;
	      }
	      window.setTimeout(function () {
	        $target.focus();
	      }, 20);
	    }
	  }, {
	    key: "showElement",
	    value: function showElement() {
	      var $target = $(this.options.target_selector);
	      if (!$target.length) {
	        console.log("Target Selector element not found with '" + this.options.target_selector + "' selector");
	        return false;
	      }
	
	      $target.show();
	    }
	  }, {
	    key: "hideElementAndEmptyChildInput",
	    value: function hideElementAndEmptyChildInput() {
	      var $target = $(this.options.target_selector);
	      if (!$target.length) {
	        console.log("Target Selector element not found with '" + this.options.target_selector + "' selector");
	        return false;
	      }
	
	      $($target).hide();
	      $("input", $target).val("");
	    }
	  }, {
	    key: "toggleClass",
	    value: function toggleClass(_mouseEvent) {
	      _mouseEvent.preventDefault();
	
	      if (typeof this.options.element_target === "undefined") {
	        console.log('toggle-class requires element_target to be set in the options');
	        return;
	      }
	
	      if (typeof this.options.class_name === "undefined") {
	        console.log('toggle-class requires class_name to be set in the options');
	        return;
	      }
	
	      var $elementTarget = null;
	      if (typeof this.options.closest_element !== "undefined" && this.options.closest_element) {
	        $elementTarget = $(_mouseEvent.currentTarget).closest(this.options.element_target);
	      } else {
	        $elementTarget = $(this.options.element_target);
	      }
	
	      if (!$elementTarget.length) {
	        console.log("No show target element found with '" + this.options.element_target + "' selector");
	        return;
	      }
	
	      var className = this.options.class_name;
	
	      if ($elementTarget.hasClass(className)) {
	        $elementTarget.removeClass(className);
	      } else {
	        $elementTarget.addClass(className);
	      }
	    }
	  }, {
	    key: "hideElementShowElement",
	    value: function hideElementShowElement(_mouseEvent) {
	      _mouseEvent.preventDefault();
	
	      if (typeof this.options.hide_target === "undefined" || typeof this.options.show_target === "undefined") {
	        console.log('hide-element-show-element requires hide_target and show_target to be set in the options');
	        return;
	      }
	
	      var $hidetarget = $(this.options.hide_target);
	      var $showTarget = $(this.options.show_target);
	
	      if (!$hidetarget.length) {
	        console.log("No hide target element found with '" + this.options.hide_target + "' selector");
	        return;
	      }
	
	      if (!$showTarget.length) {
	        console.log("No show target element found with '" + this.options.show_target + "' selector");
	        return;
	      }
	
	      $hidetarget.addClass("-hide");
	      $showTarget.removeClass("-hide");
	    }
	  }, {
	    key: "setMobileSubPageContent",
	    value: function setMobileSubPageContent(_mouseEvent) {
	      var $desktopBreakpointElement = $("#bp-desktop");
	      if ($desktopBreakpointElement.length) {
	        var desktopBreakpointSize = $desktopBreakpointElement.width();
	        if ($(window).outerWidth() >= desktopBreakpointSize) {
	          //If its desktop only, and we're below desktop size, then dont do it
	          return;
	        }
	      }
	
	      _mouseEvent.preventDefault();
	
	      if (typeof this.options.element_target === "undefined") {
	        console.log('toggle-class requires element_target to be set in the options');
	        return;
	      }
	
	      var $elementTarget = null;
	      if (typeof this.options.closest_element !== "undefined" && this.options.closest_element) {
	        $elementTarget = $(_mouseEvent.currentTarget).closest(this.options.element_target);
	      } else {
	        $elementTarget = $(".c-main-content").find(this.options.element_target);
	      }
	
	      if (!$elementTarget.length) {
	        console.log("No show target element found with '" + this.options.element_target + "' selector");
	        return;
	      }
	
	      var currentWindowScroll = $(window).scrollTop();
	      $(window).scrollTop(0);
	
	      $(".c-mobile-sub-page .content").empty();
	      //Save the scroll position, so when we close the 'popup' it goes back to the original position
	      $(".c-mobile-sub-page__header-back-btn").attr('data-original-scroll-top', currentWindowScroll);
	      $("body").addClass("-mobile-sub-page-active");
	
	      var deepCopyClone = true;
	
	      $(".c-mobile-sub-page .content").html($elementTarget.clone(deepCopyClone, deepCopyClone));
	    }
	  }, {
	    key: "closeMobileSubPageContent",
	    value: function closeMobileSubPageContent(_mouseEvent) {
	      var $desktopBreakpointElement = $("#bp-desktop");
	      if ($desktopBreakpointElement.length) {
	        var desktopBreakpointSize = $desktopBreakpointElement.width();
	        if ($(window).outerWidth() >= desktopBreakpointSize) {
	          _mouseEvent.preventDefault();
	          //If its desktop only, and we're below desktop size, then dont do it
	          return;
	        }
	      }
	      var oldWidowScrollPosition = $(".c-mobile-sub-page__header-back-btn").attr('data-original-scroll-top');
	      $("body").removeClass("-mobile-sub-page-active");
	      $(window).scrollTop(oldWidowScrollPosition);
	    }
	  }]);
	
	  return Component_ClickBehaviour;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_ClickBehaviour;
	module.exports = exports["default"];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_CulturePopUp = (function (_Abstract2) {
	  _inherits(Component_CulturePopUp, _Abstract2);
	
	  function Component_CulturePopUp(el, options) {
	    _classCallCheck(this, Component_CulturePopUp);
	
	    _get(Object.getPrototypeOf(Component_CulturePopUp.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'module');
	    this.initModule();
	  }
	
	  _createClass(Component_CulturePopUp, [{
	    key: "initModule",
	    value: function initModule() {
	      this.initListeners();
	    }
	  }, {
	    key: "initListeners",
	    value: function initListeners() {
	      var _this = this;
	      if (_this.getCookie("culture") === "") {
	        setTimeout(function () {
	          $(_this.el).removeClass("c-modal__hidden");
	        }, _this.options.popupDelayTime);
	      }
	
	      //--Cancel Button Clicked
	      function onCancelPopup() {
	        $(_this.el).fadeOut("fast");
	        _this.setCookie("culture", "true", 100000);
	      }
	
	      $(".c-modal--culture .-icon_close, .c-modal--culture .c-btn:not('.-active'),.c-modal--culture .c-modal__desc a").on("click", onCancelPopup);
	    }
	  }]);
	
	  return Component_CulturePopUp;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_CulturePopUp;
	module.exports = exports["default"];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_FullScreenHtml5Video = (function (_Abstract2) {
	  _inherits(Component_FullScreenHtml5Video, _Abstract2);
	
	  function Component_FullScreenHtml5Video(el, options) {
	    _classCallCheck(this, Component_FullScreenHtml5Video);
	
	    _get(Object.getPrototypeOf(Component_FullScreenHtml5Video.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	
	    this.initialise();
	  }
	
	  _createClass(Component_FullScreenHtml5Video, [{
	    key: "initialise",
	    value: function initialise() {}
	  }]);
	
	  return Component_FullScreenHtml5Video;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_FullScreenHtml5Video;
	module.exports = exports["default"];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_HeaderDesktop = (function (_Abstract2) {
	  _inherits(Component_HeaderDesktop, _Abstract2);
	
	  function Component_HeaderDesktop(el, options) {
	    _classCallCheck(this, Component_HeaderDesktop);
	
	    _get(Object.getPrototypeOf(Component_HeaderDesktop.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(Component_HeaderDesktop, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      // this.$el.find(".b-header__top-nav-list--products > a").click((e) => this.onProductsClicked(e));
	      // this.$el.find(".b-header__top-nav-list--learn > a").click((e) => this.onLearnClicked(e));
	      // this.$el.find(".b-header__top-nav-list--contact > a").click((e) => this.onContactClicked(e));
	      this.$el.find(".b-header__top-nav-list--products > a").mouseenter(function (e) {
	        return _this.onProductsHovered(e);
	      });
	      this.$el.find(".b-header__top-nav-list--learn > a").mouseenter(function (e) {
	        return _this.onLearnHovered(e);
	      });
	      this.$el.find(".b-header__top-nav-list--contact > a").mouseenter(function (e) {
	        return _this.onContactHovered(e);
	      });
	
	      // this.$el.find(".b-header__top-nav-list--products").mouseleave((e) => this.onHideProductsHovered(e));
	      // this.$el.find(".b-header__top-nav-list--learn").mouseleave((e) => this.onHideLearnHovered(e));
	      // this.$el.find(".b-header__top-nav-list--contact").mouseleave((e) => this.onHideContactHovered(e));
	
	      // this.$el.find(".b-header__our-products-desktop-top-navigation").mouseleave((e) => this.onTopNavigationMouseLeave(e));
	
	      this.$el.find(".b-header__top-nav-list--products").mouseleave(function (e) {
	        return _this.onProductMouseLeave(e);
	      });
	      this.$el.find(".b-header__top-nav-list--learn").mouseleave(function (e) {
	        return _this.onLearnMouseLeave(e);
	      });
	      this.$el.find(".b-header__top-nav-list--contact").mouseleave(function (e) {
	        return _this.onContactMouseLeave(e);
	      });
	
	      this.$el.find(".b-header__top-nav-list--search").click(function (e) {
	        return _this.onSearchIconClicked(e);
	      });
	      this.$el.find(".c-search-input form").submit(function (e) {
	        return _this.onSearchFormSubmitted(e);
	      });
	
	      this.$el.find(".b-header-content__dropdown").click(function (e) {
	        return _this.onCountryDropdownClicked(e);
	      });
	      this.$el.find(".b-header-content__dropdown-menu-list-item").click(function (e) {
	        return _this.onCountryDropdownListClicked(e);
	      });
	
	      this.$el.find(".b-header__our-products-desktop-left-navigation > a").click(function (e) {
	        return _this.onProductsDesktopLeftNavigationClicked(e);
	      });
	      this.$el.find(".b-header__top-nav-list--bg").click(function (e) {
	        return _this.onProductsDesktopLeftNavigationClicked(e);
	      });
	
	      $(".b-header .c-search-input--input").keyup(function (e) {
	        return _this.onSearchInputKeyUp(e);
	      });
	
	      var userAgent = navigator.userAgent.toLowerCase();
	      var isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
	      if (isTablet) {
	        if (window.matchMedia('(max-device-width : 1366px) and (orientation : landscape)').matches) {
	          this.$el.find(".b-header__top-nav-list--products > a").click(function (e) {
	            return _this.onProductsClicked(e);
	          });
	          this.$el.find(".b-header__top-nav-list--learn > a").click(function (e) {
	            return _this.onLearnClicked(e);
	          });
	          this.$el.find(".b-header__top-nav-list--contact > a").click(function (e) {
	            return _this.onContactClicked(e);
	          });
	        } else {
	          this.loadWindowOnResize();
	        }
	      }
	
	      this.searchInputPushDownOnSearchResultsPage();
	      $('body').click(function (e) {
	        return _this.bodyClicked(e);
	      });
	    }
	  }, {
	    key: "bodyClicked",
	    value: function bodyClicked(_event) {
	      if (!$('.b-header-content__dropdown-menu-wrapper').hasClass('-hidden')) {
	        $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden');
	        $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen');
	      }
	    }
	  }, {
	    key: "onCountryDropdownClicked",
	    value: function onCountryDropdownClicked(_event) {
	      _event.stopPropagation();
	      if ($('.b-header-content__dropdown-menu-wrapper').hasClass('-hidden')) {
	        $('.b-header-content__dropdown-wrapper').addClass('-dropdownopen');
	        $('.b-header-content__dropdown-menu-wrapper').removeClass('-hidden');
	      } else {
	        $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen');
	        $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden');
	      }
	    }
	  }, {
	    key: "onCountryDropdownListClicked",
	    value: function onCountryDropdownListClicked(_event) {
	      _event.stopPropagation();
	      $('.b-header-content__dropdown-menu-wrapper').addClass('-hidden');
	      $('.b-header-content__dropdown-wrapper').removeClass('-dropdownopen');
	    }
	  }, {
	    key: "onProductsClicked",
	    value: function onProductsClicked(_mouseEvent) {
	      _mouseEvent.preventDefault();
	      var $productsNavElement = this.$el.find(".b-header__top-nav-list--products");
	      if ($productsNavElement.hasClass("-expanded")) {
	        this.hideProductsItems();
	      } else {
	        // if($("html").hasClass("no-touch"))
	        // {
	        //   //Will roll over instead
	        //   return;
	        // }
	        this.showProductsItems();
	      }
	      // var $productsSideNavElem = $(".sub-nav-items.-products");
	      // if($productsSideNavElem.hasClass("-hide")) {
	      //   $productsSideNavElem.removeClass("-hide");
	      // } else {
	      //   $productsSideNavElem.addClass("-hide");
	      // }
	    }
	  }, {
	    key: "onLearnClicked",
	    value: function onLearnClicked(_mouseEvent) {
	      _mouseEvent.preventDefault();
	      var $learnNavElement = this.$el.find(".b-header__top-nav-list--learn");
	      if ($learnNavElement.hasClass("-expanded")) {
	        this.hideLearnItems();
	      } else {
	        // if($("html").hasClass("no-touch"))
	        // {
	        //   //Will roll over instead
	        //   return;
	        // }
	        this.showLearnItems();
	      }
	      // var $learnSideNavElem = $(".sub-nav-items.-learn");
	      // if($learnSideNavElem.hasClass("-hide")) {
	      //   $learnSideNavElem.removeClass("-hide");
	      // } else {
	      //   $learnSideNavElem.addClass("-hide");
	      // }
	    }
	  }, {
	    key: "onContactClicked",
	    value: function onContactClicked(_mouseEvent) {
	      _mouseEvent.preventDefault();
	      var $productsNavElement = this.$el.find(".b-header__top-nav-list--contact");
	      if ($productsNavElement.hasClass("-expanded")) {
	        this.hideContactItems();
	      } else {
	        // if($("html").hasClass("no-touch"))
	        // {
	        //   //Will roll over instead
	        //   return;
	        // }
	        this.showContactItems();
	      }
	    }
	  }, {
	    key: "onSearchInputKeyUp",
	    value: function onSearchInputKeyUp(_keyEvent) {
	      switch (_keyEvent.keyCode) {
	        case 13:
	          //enter
	          {
	            if (!window.location.origin) {
	              window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	            }
	
	            // this.onEnterPressed(_keyEvent);
	            var searchTerm = encodeURIComponent(_keyEvent.target.value);
	            var navigationLocation = window.location.origin + "/search?searchtext=" + searchTerm + "&searchmode=anyword";
	            window.location.href = navigationLocation;
	            break;
	          }
	      }
	    }
	  }, {
	    key: "onProductsHovered",
	    value: function onProductsHovered(_mouseEvent) {
	      this.showProductsItems();
	      this.onSubNavSearchItemClosed();
	    }
	  }, {
	    key: "onLearnHovered",
	    value: function onLearnHovered(_mouseEvent) {
	      this.showLearnItems();
	      this.onSubNavSearchItemClosed();
	    }
	  }, {
	    key: "onContactHovered",
	    value: function onContactHovered(_mouseEvent) {
	      this.showContactItems();
	      this.onSubNavSearchItemClosed();
	    }
	  }, {
	    key: "onHideProductsHovered",
	    value: function onHideProductsHovered(_mouseEvent) {
	      this.hideProductsItems();
	    }
	  }, {
	    key: "onHideLearnHovered",
	    value: function onHideLearnHovered(_mouseEvent) {
	      this.hideLearnItems();
	    }
	  }, {
	    key: "onHideContactHovered",
	    value: function onHideContactHovered(_mouseEvent) {
	      this.hideContactItems();
	    }
	  }, {
	    key: "onSearchIconClicked",
	    value: function onSearchIconClicked(_mouseEvent) {
	      var $topNavListSearch = this.$el.find(".b-header__top-nav-list--search");
	
	      if ($topNavListSearch.hasClass("-expanded")) {
	        //Close it
	        $topNavListSearch.removeClass("-expanded");
	        this.$el.find(".c-search-input").addClass("-hide");
	        this.onSubNavItemClosed();
	      } else {
	
	        //Open it
	        this.closeAllTopNavItems();
	        $topNavListSearch.addClass("-expanded");
	        this.showSubNavItem(".c-search-input");
	
	        this.$el.find(".c-search-input--input").focus();
	      }
	    }
	  }, {
	    key: "onProductMouseLeave",
	    value: function onProductMouseLeave(_mouseEvent) {
	
	      if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
	        return;
	      }
	
	      this.hideProductsItems();
	    }
	  }, {
	    key: "onLearnMouseLeave",
	    value: function onLearnMouseLeave(_mouseEvent) {
	
	      if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
	        return;
	      }
	
	      this.hideLearnItems();
	    }
	  }, {
	    key: "onContactMouseLeave",
	    value: function onContactMouseLeave(_mouseEvent) {
	
	      if (!this.$el.find(".b-header__top-nav-list--learn").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--products").hasClass("-expanded") && !this.$el.find(".b-header__top-nav-list--contact").hasClass("-expanded")) {
	        return;
	      }
	
	      this.hideContactItems();
	    }
	  }, {
	    key: "showLearnItems",
	    value: function showLearnItems() {
	      this.closeAllTopNavItems();
	      this.$el.find(".b-header__top-nav-list--learn").addClass("-expanded");
	      this.showSubNavItem(".b-header__top-nav-list--learn-items");
	    }
	  }, {
	    key: "hideLearnItems",
	    value: function hideLearnItems() {
	      this.$el.find(".b-header__top-nav-list--learn").removeClass("-expanded");
	      this.$el.find(".b-header__top-nav-list--learn-items").addClass("-hide");
	      this.onSubNavItemClosed();
	    }
	  }, {
	    key: "showProductsItems",
	    value: function showProductsItems() {
	      this.closeAllTopNavItems();
	      this.$el.find(".b-header__top-nav-list--products").addClass("-expanded");
	      this.showSubNavItem(".b-header__top-nav-list--products-items");
	    }
	  }, {
	    key: "hideProductsItems",
	    value: function hideProductsItems() {
	      this.$el.find(".b-header__top-nav-list--products").removeClass("-expanded");
	      this.$el.find(".b-header__top-nav-list--products-items").addClass("-hide");
	      this.onSubNavItemClosed();
	    }
	  }, {
	    key: "showContactItems",
	    value: function showContactItems() {
	      this.closeAllTopNavItems();
	      this.$el.find(".b-header__top-nav-list--contact").addClass("-expanded");
	      this.showSubNavItem(".b-header__top-nav-list--contact-items");
	    }
	  }, {
	    key: "hideContactItems",
	    value: function hideContactItems() {
	      this.$el.find(".b-header__top-nav-list--contact").removeClass("-expanded");
	      this.$el.find(".b-header__top-nav-list--contact-items").addClass("-hide");
	      this.onSubNavItemClosed();
	    }
	  }, {
	    key: "closeAllTopNavItems",
	    value: function closeAllTopNavItems() {
	      this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
	    }
	  }, {
	    key: "showSubNavItem",
	    value: function showSubNavItem(_selector) {
	      var $subNavItem = $(_selector);
	      if (!$subNavItem.length) {
	        console.log("sub nav item not found with " + _selector + " selector");
	        return;
	      }
	
	      this.onSubNavItemOpened();
	      this.$el.find(".sub-nav-items > *").addClass("-hide");
	      $subNavItem.removeClass("-hide");
	    }
	  }, {
	    key: "onSubNavItemOpened",
	    value: function onSubNavItemOpened() {
	      this.$el.find(".sub-nav-items").removeClass("-hide");
	    }
	  }, {
	    key: "onSubNavItemClosed",
	    value: function onSubNavItemClosed() {
	      this.$el.find(".sub-nav-items").addClass("-hide");
	      this.$el.find(".c-search-input__results").addClass("-hide");
	      //this.$el.find(".c-search-input--input").val("");
	    }
	  }, {
	    key: "onSubNavSearchItemClosed",
	    value: function onSubNavSearchItemClosed() {
	      this.$el.find(".c-search-input").addClass("-hide");
	      //this.$el.find(".c-search-input--input").val("");
	    }
	  }, {
	    key: "onSearchInputFocused",
	    value: function onSearchInputFocused(_mouseEvent) {
	      $(window).scrollTop(0);
	      this.$el.addClass("-search-input-focused");
	    }
	  }, {
	    key: "onSearchInputFocusOut",
	    value: function onSearchInputFocusOut(_mouseEvent) {
	      $(window).scrollTop(0);
	      this.$el.removeClass("-search-input-focused");
	    }
	  }, {
	    key: "onSearchFormSubmitted",
	    value: function onSearchFormSubmitted(_formSubmitEvent) {
	      _formSubmitEvent.preventDefault();
	      _formSubmitEvent.stopPropagation();
	
	      this.$el.find(".c-search-input__results").removeClass("-hide");
	    }
	  }, {
	    key: "onProductsDesktopLeftNavigationClicked",
	    value: function onProductsDesktopLeftNavigationClicked(_mouseEvent) {
	      var $leftNavigationElement = this.$el.find(".b-header__our-products-desktop-left-navigation");
	      if (!$leftNavigationElement.length) {
	        console.log("Could not find Left Navigation");
	        return;
	      }
	
	      if ($leftNavigationElement.hasClass("-expanded")) {
	        $leftNavigationElement.removeClass("-expanded");
	        // $("body").removeAttr("style");
	      } else {
	          $leftNavigationElement.addClass("-expanded");
	          // $("body").css("overflow","hidden");
	        }
	    }
	  }, {
	    key: "onDesktopOnlySearchClicked",
	    value: function onDesktopOnlySearchClicked(_mouseEvent) {
	      console.log("onDesktopOnlySearchClicked");
	      if (this.$el.hasClass("-child-nav-li-expanded")) {
	        this.$el.find(".c-search-input.-desktop-only").removeClass("-hide");
	      }
	    }
	  }, {
	    key: "loadWindowOnResize",
	    value: function loadWindowOnResize() {
	      $(window).resize(function (event) {
	        console.log($('Resizd'));
	        this.location.reload();
	      });
	    }
	  }, {
	    key: "searchInputPushDownOnSearchResultsPage",
	    value: function searchInputPushDownOnSearchResultsPage() {
	      if ($('.content-margin').hasClass('furnware-search-results')) {
	        $('.b-header__our-products-desktop-top-navigation').addClass('-push-search-results');
	      } else {
	        $('.b-header__our-products-desktop-top-navigation').removeClass('-push-search-results');
	      }
	    }
	  }]);
	
	  return Component_HeaderDesktop;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_HeaderDesktop;
	module.exports = exports["default"];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_HeaderMobile = (function (_Abstract2) {
	  _inherits(Component_HeaderMobile, _Abstract2);
	
	  function Component_HeaderMobile(el, options) {
	    _classCallCheck(this, Component_HeaderMobile);
	
	    _get(Object.getPrototypeOf(Component_HeaderMobile.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(Component_HeaderMobile, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.find(".c-header__mobile-close-sub-nav").click(function (e) {
	        return _this.onMobileCloseSubNav(e);
	      });
	      this.$el.find(".c-header__mobile-menu-toggle").click(function (e) {
	        return _this.onMobileMenuToggled(e);
	      });
	      this.$el.find(".b-header__top-nav-list > li > a").click(function (e) {
	        return _this.onListItemAClicked(e);
	      });
	      this.$el.find(".c-search-input .c-search-input--input").focus(function (e) {
	        return _this.onSearchInputFocused(e);
	      });
	      this.$el.find(".c-search-input form").submit(function (e) {
	        return _this.onSearchFormSubmitted(e);
	      });
	
	      $(window).resize(function (event) {
	        if ($(this).width() < 350) {
	          $('.b-header__top-nav-list.-countryselection').addClass('-pt17');
	        } else {
	          if ($('.b-header__top-nav-list.-countryselection').hasClass('-pt17')) {
	            $('.b-header__top-nav-list.-countryselection').removeClass('-pt17');
	          }
	        }
	      });
	    }
	  }, {
	    key: "onMobileCloseSubNav",
	    value: function onMobileCloseSubNav(_mouseEvent) {
	      this.$el.find(".c-search-input--input").val("");
	      this.$el.removeClass("-search-input-focused");
	      this.$el.removeClass("-has-search-results");
	      this.$el.removeClass("-child-nav-li-expanded");
	      this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
	      _mouseEvent.preventDefault();
	    }
	  }, {
	    key: "onMobileMenuToggled",
	    value: function onMobileMenuToggled(_mouseEvent) {
	      var $clickedTarget = $(_mouseEvent.currentTarget);
	
	      if (this.$el.hasClass("-expanded")) {
	        this.$el.removeClass("-expanded");
	        this.$el.removeClass("-search-input-focused");
	      } else {
	        this.$el.addClass("-expanded");
	      }
	
	      _mouseEvent.preventDefault();
	    }
	  }, {
	    key: "onListItemAClicked",
	    value: function onListItemAClicked(_mouseEvent, _bRemoveClassEnabled) {
	      if (typeof _bRemoveClassEnabled === "undefined") {
	        _bRemoveClassEnabled = true;
	      }
	
	      var $currentTarget = $(_mouseEvent.currentTarget);
	      var $currentTargetParent = $currentTarget.parent();
	      var $currentTargetUL = $currentTargetParent.find("> ul");
	      if (!$currentTargetUL.length) {
	        return;
	      }
	      _mouseEvent.preventDefault();
	      var currentTargetIsExpanded = _bRemoveClassEnabled ? $currentTargetParent.hasClass("-expanded") : false;
	      this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
	
	      if (currentTargetIsExpanded) {
	        if (_bRemoveClassEnabled) {
	          $currentTargetParent.removeClass("-expanded");
	        }
	      } else {
	        $currentTargetParent.addClass("-expanded");
	      }
	
	      if (this.$el.find(".b-header__top-nav-list > li.-expanded").length) {
	        this.$el.addClass("-child-nav-li-expanded");
	      } else {
	        if (_bRemoveClassEnabled) {
	          this.$el.removeClass("-child-nav-li-expanded");
	        }
	      }
	    }
	  }, {
	    key: "onMouseLeaveHeader",
	    value: function onMouseLeaveHeader(_mouseEvent) {
	      this.$el.find(".b-header__top-nav-list > li").removeClass("-expanded");
	      this.$el.removeClass("-child-nav-li-expanded");
	    }
	  }, {
	    key: "onSearchInputFocused",
	    value: function onSearchInputFocused(_mouseEvent) {
	      $(window).scrollTop(0);
	      this.$el.addClass("-search-input-focused");
	    }
	  }, {
	    key: "onSearchFormSubmitted",
	    value: function onSearchFormSubmitted(_formSubmitEvent) {
	      _formSubmitEvent.preventDefault();
	      _formSubmitEvent.stopPropagation();
	
	      this.$el.addClass('-has-search-results');
	    }
	  }]);
	
	  return Component_HeaderMobile;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_HeaderMobile;
	module.exports = exports["default"];

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_HoverBehaviour = (function (_Abstract2) {
	  _inherits(Component_HoverBehaviour, _Abstract2);
	
	  function Component_HoverBehaviour(el, options) {
	    _classCallCheck(this, Component_HoverBehaviour);
	
	    _get(Object.getPrototypeOf(Component_HoverBehaviour.prototype), "constructor", this).call(this, el, $.extend(true, {
	      type: false,
	      target_selector: false
	    }, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(Component_HoverBehaviour, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.hover(function (e) {
	        return _this.onElementHovered(e);
	      });
	    }
	  }, {
	    key: "onElementHovered",
	    value: function onElementHovered(e) {
	      switch (this.options.type) {
	        case "focus":
	          {
	            this.onFocusOnElement();
	            break;
	          }
	
	        case "add-class-to-other-element":
	          {
	            this.onAddClassToOtherElement();
	            break;
	          }
	
	        default:
	          {
	            return false;
	          }
	      }
	    }
	  }, {
	    key: "onAddClassToOtherElement",
	    value: function onAddClassToOtherElement() {}
	  }]);
	
	  return Component_HoverBehaviour;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_HoverBehaviour;
	module.exports = exports["default"];

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_MoveOnScroll = (function (_Abstract2) {
	    _inherits(Component_MoveOnScroll, _Abstract2);
	
	    function Component_MoveOnScroll(el, options) {
	        _classCallCheck(this, Component_MoveOnScroll);
	
	        _get(Object.getPrototypeOf(Component_MoveOnScroll.prototype), "constructor", this).call(this, el, $.extend(true, { "offset_animation_start_pixels": 0, "reverse_movement": false, "offset_animation_by_element_top_offset": false }, options), 'component');
	
	        this.BEGIN_ON_SCREEN_PERCENTAGE = typeof this.options.begin_scroll_percentage === "undefined" ? 5 : this.options.begin_scroll_percentage;
	        this.END_ON_SCREEN_PERCENTAGE = typeof this.options.end_scroll_percentage === "undefined" ? 80 : this.options.end_scroll_percentage;;
	        this.$window = $(window);
	        this.$parent = this.$el.parent();
	        this.initialise();
	    }
	
	    _createClass(Component_MoveOnScroll, [{
	        key: "initialise",
	        value: function initialise() {
	            this.setPositionBasedOnScroll();
	        }
	    }, {
	        key: "setPositionBasedOnScroll",
	        value: function setPositionBasedOnScroll() {
	            var _this = this;
	
	            var percentageOfMovement = this.getPercentageOfMovement();
	            var oneScalePercentageOfMovement = percentageOfMovement / 100;
	
	            if (this.options.reverse_movement) {
	                oneScalePercentageOfMovement = 1 - oneScalePercentageOfMovement;
	            }
	
	            var left = this.options.left * oneScalePercentageOfMovement;
	            var top = this.options.top * oneScalePercentageOfMovement;
	            this.$el.css("transform", "translate3d(" + left + "rem," + top + "rem,0)");
	
	            window.requestAnimationFrame(function () {
	                return _this.setPositionBasedOnScroll();
	            });
	        }
	    }, {
	        key: "getPercentageOfMovement",
	        value: function getPercentageOfMovement() {
	            var topOfParent = this.$parent.offset().top;
	            var windowHeight = this.$window.height();
	            var scrollTopPosition = this.$window.scrollTop();
	
	            if (this.options.offset_animation_start_pixels) {
	                scrollTopPosition -= this.options.offset_animation_start_pixels;
	            }
	
	            if (this.options.offset_animation_by_element_top_offset) {
	                scrollTopPosition -= this.$window.height() - topOfParent;
	            }
	
	            var scrollTopPlusWindowHeight = scrollTopPosition + windowHeight;
	
	            var pixelsOfElementOnScreen = scrollTopPlusWindowHeight - topOfParent;
	            var percentageOnScreen = pixelsOfElementOnScreen / windowHeight;
	            if (percentageOnScreen < 0) {
	                percentageOnScreen = 0;
	            } else if (percentageOnScreen > 1) {
	                percentageOnScreen = 1;
	            }
	
	            return percentageOnScreen * 100;
	        }
	    }]);
	
	    return Component_MoveOnScroll;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_MoveOnScroll;
	module.exports = exports["default"];

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var _libUtilsMath = __webpack_require__(35);
	
	var _libUtilsMath2 = _interopRequireDefault(_libUtilsMath);
	
	var Component_RotateOnScroll = (function (_Abstract2) {
	    _inherits(Component_RotateOnScroll, _Abstract2);
	
	    function Component_RotateOnScroll(el, options) {
	        _classCallCheck(this, Component_RotateOnScroll);
	
	        var defaultOptions = {
	            //Note the radius is based on the screen width
	            //so 1920 = 1 scale
	            //so if a radius of 400 is passed in, then at 1920 browser width it'll be 400 radius
	            //If at browser width of 960 then it'll be 200 radius
	            "radius": null,
	            "rotation_times_per_screen_height": 1, //rotation_times_per_screen_height means that it'll rotate the element once fully based on a scroll of a whole page if set to 1
	            "begin_rotation_around_point_degrees": 0,
	            "initial_image_rotation_degrees": 0,
	            "radius_percentage_of_parent_width": false //set a percentage value to determine the radius based on the parent (width /2)
	        };
	
	        _get(Object.getPrototypeOf(Component_RotateOnScroll.prototype), "constructor", this).call(this, el, $.extend(true, defaultOptions, options), 'component');
	
	        if (this.options.radius === null && !this.options.radius_percentage_of_parent_width) {
	            console.log("A radius must be passed in as an option for RotateOnScroll, or radius_percentage_of_parent_width set");
	            return;
	        }
	
	        this.$parent = this.$el.parent();
	        this.$window = $(window);
	
	        this.initialise();
	    }
	
	    _createClass(Component_RotateOnScroll, [{
	        key: "initialise",
	        value: function initialise() {
	            this.setPositionBasedOnScroll();
	        }
	    }, {
	        key: "setPositionBasedOnScroll",
	        value: function setPositionBasedOnScroll() {
	            var _this = this;
	
	            if (this.options.radius_percentage_of_parent_width) {
	                var radius = this.$parent.width() * 0.5 * (this.options.radius_percentage_of_parent_width * 0.01);
	            } else {
	                var vw = $(window).width() / 1920;
	                var radius = this.options.radius * vw;
	            }
	
	            var numberOfWindowHeightScrolled = this.getNumberOfWindowHeightScrolled();
	            var rotation = 360 * numberOfWindowHeightScrolled * this.options.rotation_times_per_screen_height + this.options.begin_rotation_around_point_degrees;
	            var numberOf360s = Math.floor(rotation / 360);
	            rotation -= 360 * numberOf360s;
	            var x = _libUtilsMath2["default"].polarToCartesianX(radius, rotation, true);
	            var y = _libUtilsMath2["default"].polarToCartesianY(radius, rotation, true);
	            this.$el.css("transform", "translate3d(" + x + "px," + y + "px,0) rotate(" + (rotation + this.options.initial_image_rotation_degrees) + "deg)");
	
	            window.requestAnimationFrame(function () {
	                return _this.setPositionBasedOnScroll();
	            });
	        }
	    }, {
	        key: "getNumberOfWindowHeightScrolled",
	        value: function getNumberOfWindowHeightScrolled() {
	            var windowHeight = this.$window.height();
	            var scrollTopPosition = this.$window.scrollTop();
	            return scrollTopPosition / windowHeight;
	        }
	    }]);
	
	    return Component_RotateOnScroll;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_RotateOnScroll;
	module.exports = exports["default"];

/***/ },
/* 35 */
/***/ function(module, exports) {

	//Created by Matthew van der Haas (matt@vdhdesign.co.nz)
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UtilsMath = (function () {
	    function UtilsMath() {
	        _classCallCheck(this, UtilsMath);
	    }
	
	    _createClass(UtilsMath, [{
	        key: "isPointWithinBounds",
	        value: function isPointWithinBounds(_pointX, _pointY, _boundsX, _boundsY, _width, _height) {
	            return _pointX >= _boundsX && _pointX <= _boundsX + _width && _pointY >= _boundsY && _pointY <= _boundsY + _height;
	        }
	    }, {
	        key: "getDistanceSquaredBetween2dPoints",
	        value: function getDistanceSquaredBetween2dPoints(_fX0, _fY0, _fX1, _fY1) {
	            var fResultX = Math.pow(_fX1 - _fX0, 2.0);
	            var fResultY = Math.pow(_fY1 - _fY0, 2.0);
	            var fResult = fResultX + fResultY;
	            return fResult;
	        }
	    }, {
	        key: "getDistanceBetween2dPoints",
	        value: function getDistanceBetween2dPoints(_point1, _point2) {
	            var fResultX = Math.pow(_point2.x - _point1.x, 2.0);
	            var fResultY = Math.pow(_point2.y - _point1.y, 2.0);
	            var fResult = Math.sqrt(fResultX + fResultY);
	            return fResult;
	        }
	    }, {
	        key: "polarToCartesianX",
	        value: function polarToCartesianX(_fPolarRadius, _fPolarAngle) {
	            var _bInDegrees = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	            if (_bInDegrees) {
	                _fPolarAngle = this.degreesToRadians(_fPolarAngle);
	            }
	
	            var fCartesianX = _fPolarRadius * Math.cos(_fPolarAngle);
	            return fCartesianX;
	        }
	    }, {
	        key: "polarToCartesianY",
	        value: function polarToCartesianY(_fPolarRadius, _fPolarAngle) {
	            var _bInDegrees = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	            if (_bInDegrees) {
	                _fPolarAngle = this.degreesToRadians(_fPolarAngle);
	            }
	
	            var fCartesianY = _fPolarRadius * Math.sin(_fPolarAngle);
	            return fCartesianY;
	        }
	    }, {
	        key: "cartesianToPolarAngle",
	        value: function cartesianToPolarAngle(_fCartesianX, _fCartesianY) {
	            var _bInDegrees = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	            var polarAngle = Math.atan(_fCartesianY / _fCartesianX);
	
	            polarAngle += this.returnRadianValueToAdd(_fCartesianX, _fCartesianY);
	
	            if (_bInDegrees) {
	                polarAngle = this.radianToDegrees(polarAngle);
	            }
	            return polarAngle;
	        }
	    }, {
	        key: "getPerpendicularCartesianX",
	        value: function getPerpendicularCartesianX(_fPolarRadius, _fPolarAngle, _bInDegrees) {
	            //todo fix for radians
	            if (_bInDegrees) {
	                _fPolarAngle -= 90;
	
	                if (_fPolarAngle < 0) {
	                    _fPolarAngle += 360;
	                }
	            }
	            //in radians
	            else {
	                    _fPolarAngle -= Math.PI / 2;
	
	                    if (_fPolarAngle < 0) {
	                        _fPolarAngle += Math.PI * 2;
	                    }
	                }
	
	            return this.polarToCartesianX(_fPolarRadius, _fPolarAngle, _bInDegrees);
	        }
	    }, {
	        key: "getPerpendicularCartesianY",
	        value: function getPerpendicularCartesianY(_fPolarRadius, _fPolarAngle, _bInDegrees) {
	            //todo fix for radians
	            if (_bInDegrees) {
	                _fPolarAngle -= 90;
	
	                if (_fPolarAngle < 0) {
	                    _fPolarAngle += 360;
	                }
	            }
	            //in radians
	            else {
	                    _fPolarAngle -= Math.PI / 2;
	
	                    if (_fPolarAngle < 0) {
	                        _fPolarAngle += Math.PI * 2;
	                    }
	                }
	            return this.polarToCartesianY(_fPolarRadius, _fPolarAngle, _bInDegrees);
	        }
	    }, {
	        key: "returnRadianValueToAdd",
	        value: function returnRadianValueToAdd(_fCartesianX, _fCartesianY) {
	            var iQuadrant = this.getQuadrant(_fCartesianX, _fCartesianY);
	            if (iQuadrant == 1) {
	                return 0;
	            } else if (iQuadrant == 2 || iQuadrant == 3) {
	                return Math.PI;
	            } else {
	                return Math.PI * 2;
	            }
	        }
	    }, {
	        key: "getQuadrant",
	        value: function getQuadrant(_fCartesianX, _fCartesianY) {
	
	            if (_fCartesianX >= 0 && _fCartesianY >= 0) {
	                return 1;
	            } else if (_fCartesianX < 0 && _fCartesianY >= 0) {
	                return 2;
	            } else if (_fCartesianX < 0 && _fCartesianY < 0) {
	                return 3;
	            } else {
	                return 4;
	            }
	        }
	    }, {
	        key: "radianToDegrees",
	        value: function radianToDegrees(_fRadian) {
	            var fInDegrees = _fRadian / Math.PI * 180;
	            return fInDegrees;
	        }
	    }, {
	        key: "degreesToRadians",
	        value: function degreesToRadians(_fDegrees) {
	            var fInRadians = _fDegrees / 180 * Math.PI;
	            return fInRadians;
	        }
	    }, {
	        key: "getRandomBool",
	        value: function getRandomBool() {
	            var randomNum = this.getRandomNumber(1, 50);
	            var randomBool = randomNum % 2 == 0;
	            return randomBool;
	        }
	
	        /**
	         * Returns a random number between min and max
	         */
	        //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FMath%2Frandom
	    }, {
	        key: "getRandomNumber",
	        value: function getRandomNumber(min, max) {
	            return Math.floor(Math.random() * (max - min + 1)) + min;
	        }
	    }, {
	        key: "getDifference",
	        value: function getDifference(_fXFrom, _fXTo) {
	            var fDifference = _fXTo - _fXFrom;
	            return fDifference;
	        }
	    }]);
	
	    return UtilsMath;
	})();
	
	exports["default"] = new UtilsMath();
	module.exports = exports["default"];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	
	// --
	// FACEBOOK SHARE
	// --
	// class that shares shareurl via facebook dialog
	//
	
	// --
	// USAGE
	// --
	//
	// data-component="share-facebook" data-component-options='{"shareURL":"[url-to-share]"}'
	//
	// "shareURL" is the site url to share ie http://uniondigital.co.nz
	//
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _shareBase = __webpack_require__(21);
	
	var _shareBase2 = _interopRequireDefault(_shareBase);
	
	var Component_share_facebook = (function (_Component_share_base) {
	  _inherits(Component_share_facebook, _Component_share_base);
	
	  function Component_share_facebook(el, options) {
	    _classCallCheck(this, Component_share_facebook);
	
	    _get(Object.getPrototypeOf(Component_share_facebook.prototype), 'constructor', this).call(this, el, $.extend(true, {
	
	      'windowTarget': 'http://www.facebook.com/sharer.php?u=',
	      'windowName': 'facebook share',
	      'windowParams': 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
	
	    }, options), 'component');
	  }
	
	  return Component_share_facebook;
	})(_shareBase2['default']);
	
	exports['default'] = Component_share_facebook;
	module.exports = exports['default'];

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	
	// --
	// LINKEDIN SHARE
	// --
	// class that shares shareurl via linkedin dialog
	//
	
	// --
	// USAGE
	// --
	//
	// data-component="share-linkedin" data-component-options='{"shareURL":"[url-to-share]"}'
	//
	// "shareURL" is the site url to share ie http://uniondigital.co.nz
	//
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _shareBase = __webpack_require__(21);
	
	var _shareBase2 = _interopRequireDefault(_shareBase);
	
	var Component_share_linkedin = (function (_Component_share_base) {
	  _inherits(Component_share_linkedin, _Component_share_base);
	
	  function Component_share_linkedin(el, options) {
	    _classCallCheck(this, Component_share_linkedin);
	
	    _get(Object.getPrototypeOf(Component_share_linkedin.prototype), 'constructor', this).call(this, el, $.extend(true, {
	
	      'windowTarget': 'http://www.linkedin.com/shareArticle?mini=true&url=',
	      'windowName': 'LinkedIn',
	      'windowParams': 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
	
	    }, options), 'component');
	  }
	
	  return Component_share_linkedin;
	})(_shareBase2['default']);
	
	exports['default'] = Component_share_linkedin;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	
	// --
	// Pinterest SHARE
	// --
	// class that shares shareurl via Pinterest dialog
	//
	
	// --
	// USAGE
	// --
	//
	// data-component="share-pinterest" data-component-options='{"shareURL":"[url-to-share]"}'
	//
	// "shareURL" is the site url to share ie http://uniondigital.co.nz
	//
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _shareBase = __webpack_require__(21);
	
	var _shareBase2 = _interopRequireDefault(_shareBase);
	
	var Component_share_pinterest = (function (_Component_share_base) {
	    _inherits(Component_share_pinterest, _Component_share_base);
	
	    function Component_share_pinterest(el, options) {
	        _classCallCheck(this, Component_share_pinterest);
	
	        var imageURL = $("head").find("meta[property='og:image']").attr("content");
	        var pageDescription = $("head").find("meta[property='og:description']").attr("content");
	        // var imageURL = typeof options.image !== "undefined" ? options.image : $("head").find("meta[property='og:image']").attr("content");
	        // var pageDescription = typeof options.description !== "undefined" ? options.description : $("head").find("meta[property='og:description']").attr("content");
	        if (!imageURL) {
	            console.log("No image passed in and could not find og image tag");
	            return;
	        }
	
	        if (!pageDescription) {
	            console.log("No description passed in and could not find og page description tag");
	            return;
	        }
	
	        _get(Object.getPrototypeOf(Component_share_pinterest.prototype), "constructor", this).call(this, el, $.extend(true, {
	
	            // <a href="http://www.pinterest.com/pin/create/button/?url={url_encoded_url}&amp;media={url_encoded_image_url}&amp;description={url_encoded_description}">Pin It</a>
	
	            'windowTarget': 'http://www.pinterest.com/pin/create/button/?media=' + imageURL + '&amp;description=' + pageDescription + '&url=',
	            'windowName': 'Pinterest',
	            'windowParams': 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
	
	        }, options), 'component');
	    }
	
	    // overload base trigerShare function
	    //combine share text with share url if share url isn't false
	
	    _createClass(Component_share_pinterest, [{
	        key: "triggerShare",
	        value: function triggerShare(event) {
	
	            this.readLatestElementOptions();
	
	            event.preventDefault();
	
	            var textToShare = "";
	
	            if (typeof this.options.shareText !== "undefined") {
	                textToShare = this.options.shareText;
	            }
	
	            if (this.options.shareURL) {
	                if (textToShare) {
	                    textToShare += " ";
	                }
	                textToShare += this.options.shareURL;
	            }
	
	            this.openSharePopup(textToShare, this.options.windowTarget, this.options.windowName, this.options.windowParams);
	        }
	    }]);
	
	    return Component_share_pinterest;
	})(_shareBase2["default"]);
	
	exports["default"] = Component_share_pinterest;
	module.exports = exports["default"];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	
	// --
	// TWITTER SHARE
	// --
	// class that shares shareTxt via twiter dialog/web intent
	//
	
	// --
	// USAGE
	// --
	//
	// data-component="share-twitter" data-component-options='{"shareURL":false,"shareText":"[share text here]"}'
	//
	// "shareURL" if set to false won't be apeneded to end of share text
	// "shareText" is the text that gets shared as a tweet
	//
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _shareBase = __webpack_require__(21);
	
	var _shareBase2 = _interopRequireDefault(_shareBase);
	
	var Component_share_twitter = (function (_Component_share_base) {
	    _inherits(Component_share_twitter, _Component_share_base);
	
	    function Component_share_twitter(el, options) {
	        _classCallCheck(this, Component_share_twitter);
	
	        _get(Object.getPrototypeOf(Component_share_twitter.prototype), 'constructor', this).call(this, el, $.extend(true, {
	
	            'windowTarget': 'https://twitter.com/intent/tweet?text=',
	            'windowName': 'twitter',
	            'windowParams': 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
	
	        }, options), 'component');
	    }
	
	    // overload base trigerShare function
	    //combine share text with share url if share url isn't false
	
	    _createClass(Component_share_twitter, [{
	        key: 'triggerShare',
	        value: function triggerShare(event) {
	
	            this.readLatestElementOptions();
	
	            event.preventDefault();
	
	            var textToShare = this.options.shareText;
	
	            if (this.options.shareURL) {
	                textToShare = textToShare + " " + this.options.shareURL;
	            }
	
	            this.openSharePopup(textToShare, this.options.windowTarget, this.options.windowName, this.options.windowParams);
	        }
	    }]);
	
	    return Component_share_twitter;
	})(_shareBase2['default']);
	
	exports['default'] = Component_share_twitter;
	module.exports = exports['default'];

/***/ },
/* 40 */,
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_SocialNetworksPopup = (function (_Abstract2) {
	  _inherits(Component_SocialNetworksPopup, _Abstract2);
	
	  function Component_SocialNetworksPopup(el, options) {
	    _classCallCheck(this, Component_SocialNetworksPopup);
	
	    _get(Object.getPrototypeOf(Component_SocialNetworksPopup.prototype), "constructor", this).call(this, el, $.extend(true, {}, options), 'component');
	    this.bindEvents();
	  }
	
	  _createClass(Component_SocialNetworksPopup, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.click(function (e) {
	        return _this.onTriggerElementClicked(e);
	      });
	    }
	  }, {
	    key: "onTriggerElementClicked",
	    value: function onTriggerElementClicked(e) {
	      console.log("onTriggerElementClicked");
	    }
	  }]);
	
	  return Component_SocialNetworksPopup;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_SocialNetworksPopup;
	module.exports = exports["default"];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	//A simple component which just toggles a class in all immediate children of the element this component is attached to
	
	var Component_ToggleChildClasses = (function (_Abstract2) {
	  _inherits(Component_ToggleChildClasses, _Abstract2);
	
	  function Component_ToggleChildClasses(el, options) {
	    _classCallCheck(this, Component_ToggleChildClasses);
	
	    _get(Object.getPrototypeOf(Component_ToggleChildClasses.prototype), "constructor", this).call(this, el, $.extend(true, {
	      toggle_class: false
	    }, options), 'component');
	
	    if (!this.options.toggle_class) {
	      console.log("Toggle Child Classes component has no toggle_class specified");
	      return;
	    }
	
	    this.bindEvents();
	  }
	
	  _createClass(Component_ToggleChildClasses, [{
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this = this;
	
	      this.$el.on("click", "> *", function (e) {
	        return _this.immediateChildClicked(e);
	      });
	    }
	  }, {
	    key: "immediateChildClicked",
	    value: function immediateChildClicked(e) {
	      console.log("immediate");
	      var $target = $(e.currentTarget);
	      if ($target.hasClass(this.options.toggle_class)) {
	        $target.removeClass(this.options.toggle_class);
	      } else {
	        $target.addClass(this.options.toggle_class);
	      }
	    }
	  }]);
	
	  return Component_ToggleChildClasses;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_ToggleChildClasses;
	module.exports = exports["default"];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_VerticalSlide = (function (_Abstract2) {
	  _inherits(Component_VerticalSlide, _Abstract2);
	
	  function Component_VerticalSlide(el, options) {
	    _classCallCheck(this, Component_VerticalSlide);
	
	    _get(Object.getPrototypeOf(Component_VerticalSlide.prototype), "constructor", this).call(this, el, $.extend(true, {
	      //scroll_per_pixel_multiplier takes the number of pixels it has scrolled onthe page, and then multiplies it by this
	      //So the lower the number the 'slower' it appears, as it is actually closer to matching the speed of the scrolling itself
	      scroll_per_pixel_multiplier: 0.08
	    }, options), 'component');
	
	    this.PERENTAGE_OF_ASSET_TO_BE_ON_SCREEN_TO_START = 0;
	
	    this.$window = $(window);
	    this.initialise();
	  }
	
	  _createClass(Component_VerticalSlide, [{
	    key: "initialise",
	    value: function initialise() {
	      this.setPositionBasedOnScroll();
	    }
	  }, {
	    key: "isElementOnScreen",
	    value: function isElementOnScreen() {
	      return this.$el.offset().top < this.$window.scrollTop() + this.$window.height();
	    }
	  }, {
	    key: "setPositionBasedOnScroll",
	    value: function setPositionBasedOnScroll() {
	      var _this = this;
	
	      var bIsElementOnScreen = this.isElementOnScreen();
	      if (!bIsElementOnScreen) {
	        window.requestAnimationFrame(function () {
	          return _this.setPositionBasedOnScroll();
	        });
	        return;
	      }
	
	      this.$el.css("transform", "none");
	      var pixelsOfElementRequiredOnScreen = this.$el.height() * (this.PERENTAGE_OF_ASSET_TO_BE_ON_SCREEN_TO_START * 0.001);
	      var originalPositionPlusRequiredOnScreen = this.$el.offset().top + pixelsOfElementRequiredOnScreen;
	      var pixelsFromBottomOfScreen = this.$window.scrollTop() + this.$window.height() - originalPositionPlusRequiredOnScreen;
	      this.$el.css("transform", "translate3d(0," + pixelsFromBottomOfScreen * this.options.scroll_per_pixel_multiplier + "rem,0)");
	      window.requestAnimationFrame(function () {
	        return _this.setPositionBasedOnScroll();
	      });
	    }
	  }]);
	
	  return Component_VerticalSlide;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_VerticalSlide;
	module.exports = exports["default"];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _systemAbstract = __webpack_require__(5);
	
	var _systemAbstract2 = _interopRequireDefault(_systemAbstract);
	
	var Component_VideoPlayer = (function (_Abstract2) {
	  _inherits(Component_VideoPlayer, _Abstract2);
	
	  function Component_VideoPlayer(el, options) {
	    _classCallCheck(this, Component_VideoPlayer);
	
	    _get(Object.getPrototypeOf(Component_VideoPlayer.prototype), "constructor", this).call(this, el, $.extend(true, {
	      type: false,
	      target_selector: false
	    }, options), 'component');
	
	    this.bindEvents();
	  }
	
	  _createClass(Component_VideoPlayer, [{
	    key: "bindEvents",
	    value: function bindEvents() {}
	  }]);
	
	  return Component_VideoPlayer;
	})(_systemAbstract2["default"]);
	
	exports["default"] = Component_VideoPlayer;
	module.exports = exports["default"];

/***/ }
]);


/** WEBPACK FOOTER **
 ** 2.2.js
 **/